import { render, staticRenderFns } from "./iconDialog.vue?vue&type=template&id=51fb6379&scoped=true&"
import script from "./iconDialog.vue?vue&type=script&lang=js&"
export * from "./iconDialog.vue?vue&type=script&lang=js&"
import style0 from "./iconDialog.vue?vue&type=style&index=0&id=51fb6379&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fb6379",
  null
  
)

export default component.exports